const downloadInFrame = (url) => {
    const frame = document.createElement('iframe');
    frame.setAttribute('title', 'Delivery reports download');
    frame.setAttribute('aria-hidden', 'true');
    frame.style.display = 'none';
    frame.src = url;
    document.body.appendChild(frame);
    return () => frame.remove();
};

export default downloadInFrame;
